import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Form, Button, Alert } from 'react-bootstrap';
import AuthPage from '../components/layout/AuthPage';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || ''}/api/auth/forgot-password`,
        { email },
      );
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthPage>
      <h1 className="auth-card__title">Reset Password</h1>
      <p className="auth-card__subtitle">Enter your email and we will send you a reset link.</p>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" className="button w-100" disabled={submitting}>
          {submitting ? 'Sending...' : 'Send Reset Link'}
        </Button>
      </Form>

      {message && <Alert variant="success" className="mt-3 mb-0">{message}</Alert>}
      {error && <Alert variant="danger" className="mt-3 mb-0">{error}</Alert>}

      <p className="text-center mt-3 mb-0">
        <span className="auth-link" onClick={() => navigate('/app')}>Back to Login</span>
      </p>
    </AuthPage>
  );
};

export default ForgotPassword;